import React from 'react';
import { I18n } from '@aws-amplify/core';

import { InfoCircleIcon } from '@/assets/icons/v2';

import { RevisionAlert } from './styles';

interface InfoBannerProps {
	message: string;
}

export function InfoBanner({ message }: Readonly<InfoBannerProps>): JSX.Element {
	return <RevisionAlert closable showIcon type="info" icon={<InfoCircleIcon />} message={I18n.get(message)} />;
}
